import type { ReactNode } from 'react';
import { Redirect } from 'wouter';
import { useAuth } from '../lib/AuthContext';
import { AppShell } from './layout/AppShell';
import { Loader } from './ui/Spinner';
export function ProtectedRoute({ children }: { children: ReactNode }) { const { user, restoring } = useAuth(); if (restoring) return <Loader fullScreen />; if (!user) return <Redirect to="/login" />; return <AppShell>{children}</AppShell>; }
